import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteData,
  recordFiltering,
  findData,
} from '~/store/modules/justificativaContingencia/actions';

import Form from './form';

function JustificativaContingencia() {
  const redux = useSelector((state) => state.justificativaContingencia);

  const options = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'descricaojustificativacontingencia',
        label: t(
          's.configuracao.justificativacontingencia.descricaojustificativacontingencia'
        ),
        filter: { type: 'text' },
      },
      {
        id: 'statusjustificativacontingencia',
        label: t(
          's.configuracao.justificativacontingencia.statusjustificativacontingencia'
        ),
        formatted: (value) =>
          options.find((o) => o.label === value).value || '',
        filter: { type: 'select', options },
      },
    ],
    [options]
  );

  const fieldlist = [
    'descricaojustificativacontingencia',
    'statusjustificativacontingencia',
  ];

  const substituirHeader = {
    descricaojustificativacontingencia: t(
      's.configuracao.justificativacontingencia.descricaojustificativacontingencia'
    ),
    statusjustificativacontingencia: t(
      's.configuracao.justificativacontingencia.statusjustificativacontingencia'
    ),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys={['idjustificativacontingencia']}
      detach="descricaojustificativacontingencia"
      excel
      pdf
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'justificativascontingencias',
          formato,
          fields: fieldlist,
          redux,
          headers: substituirHeader,
          title: 'Relatório de Contingências',
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          substituirValores: {
            statusjustificativacontingencia: {
              L: t('s.geral.opcoes.liberado'),
              B: t('s.geral.opcoes.bloqueado'),
            },
          },
        })
      }
    />
  );
}

export default JustificativaContingencia;
